/**
 * Буфер последних клиентских ошибок для багрепорта (§П5.2).
 *
 * Назначение файла: хранит коды отказов без содержимого запросов; координаты не пишутся.
 */

import { SUPPORT_CLIENT_ERRORS_LIMIT } from "@hive/shared";

export type ClientErrorEntry = {
  readonly code: string;
  readonly at: string;
};

const buffer: ClientErrorEntry[] = [];

/** Запоминает код ошибки для следующей жалобы. */
export function recordClientError(code: string): void {
  buffer.unshift({ code, at: new Date().toISOString() });
  if (buffer.length > SUPPORT_CLIENT_ERRORS_LIMIT) {
    buffer.length = SUPPORT_CLIENT_ERRORS_LIMIT;
  }
}

/** Копия последних ошибок для отправки на сервер. */
export function snapshotClientErrors(): readonly ClientErrorEntry[] {
  return [...buffer];
}

/** Очищает буфер после успешной отправки жалобы. */
export function clearClientErrors(): void {
  buffer.length = 0;
}
